
import Vue from 'vue';
import Bar from '@/components/BarChat/index.vue';
import Pie from '@/components/PieChart/index.vue';
import LineChart from '@/components/LineChart/index.vue';
import { Grid } from './styles';

export default Vue.extend({
  components: {
    Bar,
    Grid,
    Pie,
    LineChart,
  },
  computed: {
    barData() {
      return {
        labels: ['1º Trimestre', '2º Trimestre', '3º Trimestre', '4º Trimestre'],
        datasets: [
          {
            label: 'Ativos',
            data: [3, 1, 2, 4],
            backgroundColor: '#22aa99',
          },
          {
            label: 'Inativos',
            data: [1, 2, 1, 2],
            backgroundColor: '#994499',
          },
          {
            label: 'Outros',
            data: [1, 1, 2, 4],
            backgroundColor: '#b82e2e',
          },
        ],
      };
    },
    barOptions() {
      return {
        responsive: true,
        scales: {
          x: { stacked: true },
          y: { stacked: true },
        },
        plugins: {
          title: {
            display: true,
            text: 'Territórios cadastrados',
          },
        },
      };
    },
    pieVoucherData() {
      return {
        labels: ['1º Trimestre', '2º Trimestre', '3º Trimestre', '4º Trimestre'],
        datasets: [
          {
            data: [40, 20, 80, 10],
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
          },
        ],
      };
    },
    pieVoucherOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Voucher',
          },
        },
      };
    },
    piePenaltyData() {
      return {
        labels: ['1º Trimestre', '2º Trimestre', '3º Trimestre', '4º Trimestre'],
        datasets: [
          {
            data: [49, 21, 5, 10],
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
          },
        ],
      };
    },
    piePenaltyOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Multa indenizatória ($)',
          },
        },
      };
    },
    lineChartData() {
      return {
        labels: ['1º Trimestre', '2º Trimestre', '3º Trimestre', '4º Trimestre'],
        datasets: [
          {
            label: 'Analisando',
            data: [40, 39, 10, 8],
            backgroundColor: '#22aa99',
          },
          {
            label: 'Rejeitado',
            data: [60, 39, 80, 56],
            backgroundColor: '#994499',
          },
          {
            label: 'Série',
            data: [10, 5, 44, 28],
            backgroundColor: '#b82e2e',
          },
        ],
      };
    },
    lineChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Documentos de contestação',
          },
        },
      };
    },
  },
});
